import React, { forwardRef } from 'react';
import FormField from './FormField';

export interface CheckboxFieldProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  description?: string;
  error?: string;
  required?: boolean;
  checkboxLabel: string;
  checkboxDescription?: string;
}

/**
 * Reusable checkbox field component
 * Includes label, description, and error handling
 */
const CheckboxField = forwardRef<HTMLInputElement, CheckboxFieldProps>(
  (
    {
      label,
      description,
      error,
      required = false,
      checkboxLabel,
      checkboxDescription,
      className = '',
      ...props
    },
    ref
  ) => {
    return (
      <FormField
        label={label}
        description={description}
        error={error}
        required={required}
      >
        <div className="flex items-start">
          <div className="flex items-center h-5">
            <input
              ref={ref}
              type="checkbox"
              className={`rounded h-5 w-5 text-primary-600 focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 cursor-pointer ${
                error ? 'border-red-500' : 'border-gray-300'
              } ${className}`}
              {...props}
            />
          </div>
          <div className="ml-3">
            <label htmlFor={props.id} className="text-sm font-medium text-gray-700 cursor-pointer">
              {checkboxLabel}
            </label>
            {checkboxDescription && (
              <p className="text-xs text-gray-500 mt-0.5">{checkboxDescription}</p>
            )}
          </div>
        </div>
      </FormField>
    );
  }
);

CheckboxField.displayName = 'CheckboxField';

export default CheckboxField;
